module.exports = __webpack_public_path__ + "img/home_fitness1.f373cc5f.jpg";